"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _UIControlledPopover = _interopRequireDefault(require("./UIControlledPopover"));

var _default = (0, _Controllable.default)(_UIControlledPopover.default, ['open']);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/tooltip/UIPopover.js
// module id = 603
// module chunks = 5 6